import React from "react";

export const AffiliateHeaderContext = React.createContext(null);
